export enum LOCATION_DROPDOWN_STORAGE_KEYS {
  AllLocationsSelectedPreference = "all-location-selected-preference",
  LocationSelectedPreference = "location-selected-preference",
  DealerSelectedPreference = "dealer-selected-preference"
}
